export { default as name } from './name';
export { default as priceSpecification } from './priceSpecification';
// export { default as customProperties } from './custom-properties';
